const audios = {
  data() {
    return {
      audioCarta1: new Audio(require('@/assets/audios/carta1.mp3')),
      audioCarta2: new Audio(require('@/assets/audios/carta2.mp3')),
      audioCarta3: new Audio(require('@/assets/audios/carta3.mp3')),
      audioCarta4: new Audio(require('@/assets/audios/carta4.mp3')),
      audioCarta5: new Audio(require('@/assets/audios/carta5.mp3')),
      audioPoema: new Audio(require('@/assets/audios/poema.mp3')),
      audioAdelson: new Audio(require('@/assets/audios/adelson.mp3')),
      audioAldaberto: new Audio(require('@/assets/audios/aldaberto.mp3')),
      audioAldemir: new Audio(require('@/assets/audios/aldemir.mp3')),
      audioGenivaldo: new Audio(require('@/assets/audios/genivaldo.mp3')),
      audioJose: new Audio(require('@/assets/audios/jose.mp3')),
      audioJane: new Audio(require('@/assets/audios/jane.mp3')),
      audioRoberio: new Audio(require('@/assets/audios/roberio.mp3')),
      audioCarta1Playing: false,
      audioCarta2Playing: false,
      audioCarta3Playing: false,
      audioCarta4Playing: false,
      audioCarta5Playing: false,
      audioPoemaPlaying: false,
      audioAdelsonPlaying: false,
      audioAldabertoPlaying: false,
      audioAldemirPlaying: false,
      audioGenivaldoPlaying: false,
      audioJosePlaying: false,
      audioJanePlaying: false,
      audioRoberioPlaying: false,
    }
  },
  mounted() {
    this.audioCarta1.addEventListener('ended', () => {
      this.audioCarta1Playing = false
    })
    this.audioCarta2.addEventListener('ended', () => {
      this.audioCarta2Playing = false
    })
    this.audioCarta3.addEventListener('ended', () => {
      this.audioCarta3Playing = false
    })
    this.audioCarta4.addEventListener('ended', () => {
      this.audioCarta4Playing = false
    })
    this.audioCarta5.addEventListener('ended', () => {
      this.audioCarta5Playing = false
    })
    this.audioPoema.addEventListener('ended', () => {
      this.audioPoemaPlaying = false
    })
    this.audioAdelson.addEventListener('ended', () => {
      this.audioAdelsonPlaying = false
    })
    this.audioAldaberto.addEventListener('ended', () => {
      this.audioAldabertoPlaying = false
    })
    this.audioAldemir.addEventListener('ended', () => {
      this.audioAldemirPlaying = false
    })
    this.audioGenivaldo.addEventListener('ended', () => {
      this.audioGenivaldoPlaying = false
    })
    this.audioJose.addEventListener('ended', () => {
      this.audioJosePlaying = false
    })
    this.audioJane.addEventListener('ended', () => {
      this.audioJanePlaying = false
    })
    this.audioRoberio.addEventListener('ended', () => {
      this.audioRoberioPlaying = false
    })
  },

  methods: {
    isPlaying(audio) {
      return audio && audio.currentTime > 0 && !audio.paused && !audio.ended && audio.readyState > 2
    },
    ligarSomFundo() {
      // if (this.armazenarUltimoFundo) {
      //   this.$store.commit('ligarFundo')
      // }
    },
    desligarSomFundo() {
      // this.armazenarUltimoFundo = this.$store.state.soundFundo
      // setTimeout(() => {
      //   this.$store.commit('desligarFundo')
      // }, 100)
    },
    audioCarta1Play() {
      this.stopAllCartas()
      this.audioCarta1.addEventListener('ended', () => {
        this.audioCarta1Playing = false
      })
      this.audioCarta1.play()
      this.audioCarta1Playing = true
    },
    audioCarta2Play() {
      this.stopAllCartas()
      this.audioCarta2.addEventListener('ended', () => {
        this.audioCarta2Playing = false
      })
      this.audioCarta2.play()
      this.audioCarta2Playing = true
    },
    audioCarta3Play() {
      this.stopAllCartas()
      this.audioCarta3.addEventListener('ended', () => {
        this.audioCarta3Playing = false
      })
      this.audioCarta3.play()
      this.audioCarta3Playing = true
    },
    audioCarta4Play() {
      this.stopAllCartas()
      this.audioCarta4.addEventListener('ended', () => {
        this.audioCarta4Playing = false
      })
      this.audioCarta4.play()
      this.audioCarta4Playing = true
    },
    audioCarta5Play() {
      this.stopAllCartas()
      this.audioCarta5.addEventListener('ended', () => {
        this.audioCarta5Playing = false
      })
      this.audioCarta5.play()
      this.audioCarta5Playing = true
    },
    audioPoemaPlay() {
      this.stopAllCartas()
      this.audioPoema.addEventListener('ended', () => {
        this.audioPoemaPlaying = false
      })
      this.audioPoema.play()
      this.audioPoemaPlaying = true
    },
    audioAdelsonPlay() {
      this.stopAllCartas()
      this.audioAdelson.addEventListener('ended', () => {
        this.audioAdelsonPlaying = false
      })
      this.audioAdelson.play()
      this.audioAdelsonPlaying = true
    },
    audioAldabertoPlay() {
      this.stopAllCartas()
      this.audioAldaberto.addEventListener('ended', () => {
        this.audioAldabertoPlaying = false
      })
      this.audioAldaberto.play()
      this.audioAldabertoPlaying = true
    },
    audioAldemirPlay() {
      this.stopAllCartas()
      this.audioAldemir.addEventListener('ended', () => {
        this.audioAldemirPlaying = false
      })
      this.audioAldemir.play()
      this.audioAldemirPlaying = true
    },
    audioGenivaldoPlay() {
      this.stopAllCartas()
      this.audioGenivaldo.addEventListener('ended', () => {
        this.audioGenivaldoPlaying = false
      })
      this.audioGenivaldo.play()
      this.audioGenivaldoPlaying = true
    },
    audioJosePlay() {
      this.stopAllCartas()
      this.audioJose.addEventListener('ended', () => {
        this.audioJosePlaying = false
      })
      this.audioJose.play()
      this.audioJosePlaying = true
    },
    audioJanePlay() {
      this.stopAllCartas()
      this.audioJane.addEventListener('ended', () => {
        this.audioJanePlaying = false
      })
      this.audioJane.play()
      this.audioJanePlaying = true
    },
    audioRoberioPlay() {
      this.stopAllCartas()
      this.audioRoberio.addEventListener('ended', () => {
        this.audioRoberioPlaying = false
      })
      this.audioRoberio.play()
      this.audioRoberioPlaying = true
    },
    audioCarta1Stop() {
      this.audioCarta1.removeEventListener(
        'ended',
        () => {
          this.audioCarta1Playing = false
        },
        false
      )
      this.audioCarta1.pause()
      this.audioCarta1.currentTime = 0
      this.audioCarta1Playing = false
    },
    audioCarta2Stop() {
      this.audioCarta2.removeEventListener(
        'ended',
        () => {
          this.audioCarta2Playing = false
        },
        false
      )
      this.audioCarta2.pause()
      this.audioCarta2.currentTime = 0
      this.audioCarta2Playing = false
    },
    audioCarta3Stop() {
      this.audioCarta3.removeEventListener(
        'ended',
        () => {
          this.audioCarta3Playing = false
        },
        false
      )
      this.audioCarta3.pause()
      this.audioCarta3.currentTime = 0
      this.audioCarta3Playing = false
    },
    audioCarta4Stop() {
      this.audioCarta4.removeEventListener(
        'ended',
        () => {
          this.audioCarta4Playing = false
        },
        false
      )
      this.audioCarta4.pause()
      this.audioCarta4.currentTime = 0
      this.audioCarta4Playing = false
    },
    audioCarta5Stop() {
      this.audioCarta5.removeEventListener(
        'ended',
        () => {
          this.audioCarta5Playing = false
        },
        false
      )
      this.audioCarta5.pause()
      this.audioCarta5.currentTime = 0
      this.audioCarta5Playing = false
    },
    audioPoemaStop() {
      this.audioPoema.removeEventListener(
        'ended',
        () => {
          this.audioPoemaPlaying = false
        },
        false
      )
      this.audioPoema.pause()
      this.audioPoema.currentTime = 0
      this.audioPoemaPlaying = false
    },
    audioAdelsonStop() {
      this.audioAdelson.removeEventListener(
        'ended',
        () => {
          this.audioAdelsonPlaying = false
        },
        false
      )
      this.audioAdelson.pause()
      this.audioAdelson.currentTime = 0
      this.audioAdelsonPlaying = false
    },
    audioAldabertoStop() {
      this.audioAldaberto.removeEventListener(
        'ended',
        () => {
          this.audioAldabertoPlaying = false
        },
        false
      )
      this.audioAldaberto.pause()
      this.audioAldaberto.currentTime = 0
      this.audioAldabertoPlaying = false
    },
    audioAldemirStop() {
      this.audioAldemir.removeEventListener(
        'ended',
        () => {
          this.audioAldemirPlaying = false
        },
        false
      )
      this.audioAldemir.pause()
      this.audioAldemir.currentTime = 0
      this.audioAldemirPlaying = false
    },
    audioGenivaldoStop() {
      this.audioGenivaldo.removeEventListener(
        'ended',
        () => {
          this.audioGenivaldoPlaying = false
        },
        false
      )
      this.audioGenivaldo.pause()
      this.audioGenivaldo.currentTime = 0
      this.audioGenivaldoPlaying = false
    },
    audioJoseStop() {
      this.audioJose.removeEventListener(
        'ended',
        () => {
          this.audioJosePlaying = false
        },
        false
      )
      this.audioJose.pause()
      this.audioJose.currentTime = 0
      this.audioJosePlaying = false
    },
    audioJaneStop() {
      this.audioJane.removeEventListener(
        'ended',
        () => {
          this.audioJanePlaying = false
        },
        false
      )
      this.audioJane.pause()
      this.audioJane.currentTime = 0
      this.audioJanePlaying = false
    },
    audioRoberioStop() {
      this.audioRoberio.removeEventListener(
        'ended',
        () => {
          this.audioRoberioPlaying = false
        },
        false
      )
      this.audioRoberio.pause()
      this.audioRoberio.currentTime = 0
      this.audioRoberioPlaying = false
    },
    stopAllCartas() {
      this.audioCarta1Stop()
      this.audioCarta2Stop()
      this.audioCarta3Stop()
      this.audioCarta4Stop()
      this.audioCarta5Stop()
      this.audioPoemaStop()
    },
    stopAllPessoas() {
      this.audioAdelsonStop()
      this.audioAldabertoStop()
      this.audioAldemirStop()
      this.audioGenivaldoStop()
      this.audioJoseStop()
      this.audioJaneStop()
      this.audioRoberioStop()
    },

    playAudioPessoa(pessoa) {
      this.stopAllPessoas()
      switch (pessoa) {
        case 'adelson':
          this.desligarSomFundo()
          this.audioAdelsonPlay()
          break
        case 'aldaberto':
          this.desligarSomFundo()
          this.audioAldabertoPlay()
          break
        case 'aldemir':
          this.desligarSomFundo()
          this.audioAldemirPlay()
          break
        case 'genivaldo':
          this.desligarSomFundo()
          this.audioGenivaldoPlay()
          break
        case 'jose':
          this.desligarSomFundo()
          this.audioJosePlay()
          break
        case 'jane':
          this.desligarSomFundo()
          this.audioJanePlay()
          break
        case 'roberio':
          this.desligarSomFundo()
          this.audioRoberioPlay()
          break
        default:
          break
      }
    },
  },
}

export default audios
